import { useCallback, useState } from 'react';
import session from '../store/session';
import { isPreviewMode, toParam } from '../utils/tool';
import { useStore } from './useStore';
export const setStorage = (key, val, expire) => {
  if (isPreviewMode()) {
    return;
  }

  const item = {
    value: val,
    expire: expire ? Date.now() + expire : NaN
  };
  localStorage.setItem(key, JSON.stringify(item));
};
export const getStorage = key => {
  if (isPreviewMode()) {
    return undefined;
  }

  const val = localStorage.getItem(key) || '';

  try {
    const item = JSON.parse(val);

    if (item.expire && Date.now() < item.expire) {
      return undefined;
    }

    return item.value;
  } catch (e) {
    return undefined;
  }
};
export const useCacheState = (key, initialState) => {
  const initialValue = getStorage(key);
  const [state, setState] = useState(typeof initialValue !== 'undefined' ? initialValue : initialState);
  const set = useCallback(val => {
    setState(val);
    setStorage(key, val);
  }, [key]);

  const clear = () => {};

  return [state, set, {
    clear
  }];
};
export const useSessionState = (key, initialState) => {
  const sessionVal = session.get(key);
}; // 针对每个投保配置和商品id读写本地缓存状态

export const useCacheStateByPage = (key, initialState) => {
  const [config] = useStore('configJson');
  const {
    templateId,
    goodsId,
    insureConfigId
  } = config;
  const nextKey = toParam({
    key,
    templateId,
    goodsId,
    insureConfigId
  });
  return useCacheState(nextKey, initialState);
};
export default useCacheState;